"use client";
import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";

const DEFAULT_BANNER_IMAGE = "/image/plsyy/home/banner.webp";

function HomeBanner() {
	const t = useTranslations();

	return (
		<div className="banner relative w-full h-[50vh] md:h-full flex items-center justify-center overflow-hidden bg-black">
			<div className="b-flex relative w-full h-full max-md:flex-col">
				<span className="sr-only">{t("menu.Home")}</span>
				<div className="absolute inset-0 w-full h-full z-0">
					<Image
						src={DEFAULT_BANNER_IMAGE}
						alt="Home banner"
						fill
						className="object-cover"
						priority
						sizes="100vw"
					/>
				</div>
			</div>

			<button
				type="button"
				disabled
				aria-label="Banner video disabled"
				className="absolute top-1/2 right-2 z-30 w-10 h-10 bg-white/10 backdrop-blur-md border border-white/20 text-white rounded-full flex items-center justify-center opacity-50 cursor-not-allowed"
			>
				<i className="ri-arrow-right-s-line text-xl transition-transform" aria-hidden="true"></i>
			</button>
			
			{/* 鼠标下滑提示 */}
			<div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center">
				<style dangerouslySetInnerHTML={{__html: `
					@keyframes mouseScroll {
						0% {
							transform: translateY(0);
							opacity: 1;
						}
						50% {
							transform: translateY(12px);
							opacity: 0.3;
						}
						100% {
							transform: translateY(0);
							opacity: 1;
						}
					}
					@keyframes mouseFade {
						0% {
							color: rgba(255, 255, 255, 0.9);
						}
						50% {
							color: rgba(255, 255, 255, 0.2);
						}
						100% {
							color: rgba(255, 255, 255, 0.9);
						}
					}
					@keyframes wheelMove {
						0% {
							transform: translateY(0);
							opacity: 1;
						}
						50% {
							transform: translateY(10px);
							opacity: 0.2;
						}
						100% {
							transform: translateY(0);
							opacity: 1;
						}
					}
					.mouse-scroll-indicator {
						animation: mouseScroll 2s ease-in-out infinite;
					}
					.mouse-icon {
						animation: mouseFade 2s ease-in-out infinite;
					}
					.mouse-wheel {
						animation: wheelMove 2s ease-in-out infinite;
					}
				`}} />
				<div className="mouse-scroll-indicator">
					<svg
						width="24"
						height="40"
						viewBox="0 0 24 40"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="mouse-icon"
						style={{ color: "rgba(255, 255, 255, 0.8)" }}
					>
						{/* 鼠标外框 */}
						<rect
							x="2"
							y="2"
							width="20"
							height="32"
							rx="10"
							stroke="currentColor"
							strokeWidth="2"
							fill="none"
						/>
						{/* 鼠标滚轮 */}
						<circle
							cx="12"
							cy="12"
							r="2"
							fill="currentColor"
							className="mouse-wheel"
						/>
					</svg>
				</div>
			</div>
		</div>
	);
}
export default React.memo(HomeBanner);
